import {reactive} from 'vue'
import store from '@/store'
import request from '@/utils/request'
export const adminTutorialPolicy=reactive({enabled:false,ready:false,error:'',saving:false})
let revision=0
const identity=()=>JSON.stringify([store.getters.token,store.getters.userInfo?.id,store.getters.userInfo?.orgId])
export function resetAdminTutorialPolicy(){revision++;adminTutorialPolicy.enabled=false;adminTutorialPolicy.ready=false;adminTutorialPolicy.error=''}
export async function refreshAdminTutorialPolicy(){
 const scope=identity(),version=++revision
 if(!store.getters.token){resetAdminTutorialPolicy();return}
 try{const response=await request({url:'system/adminTutorials',method:'GET'});if(version!==revision || scope!==identity())return
  if(typeof response.data?.enabled!=='boolean')throw Error('教程设置返回不完整')
  adminTutorialPolicy.enabled=response.data.enabled;adminTutorialPolicy.ready=true;adminTutorialPolicy.error=''
 // 2026-10-31：兼容旧后端返回原始SQL异常，页面固定显示中文重试提示，不暴露数据库结构。
 }catch(_error){if(version===revision && scope===identity()){adminTutorialPolicy.enabled=false;adminTutorialPolicy.ready=false;adminTutorialPolicy.error='教程设置加载失败，请点击重新加载'}}
}
export async function saveAdminTutorialPolicy(enabled:boolean){
 const scope=identity(),version=++revision;adminTutorialPolicy.saving=true
 try{const response=await request({url:'system/adminTutorials',method:'PUT',data:{enabled}});if(version!==revision || scope!==identity())throw Error('账号已变化，请重试')
  if(response.data?.enabled!==enabled)throw Error('教程设置未确认，请刷新重试')
  adminTutorialPolicy.enabled=enabled;adminTutorialPolicy.ready=true;adminTutorialPolicy.error=''
 }catch(_error){throw Error('教程设置保存失败，请刷新后重试')}finally{adminTutorialPolicy.saving=false}
}
